// The one place that knows where the API is. Production is same-origin (server/app.py serves
// this app under /app/ and the API at the root); dev goes through Vite's /api proxy.
export const API = import.meta.env.DEV ? "/api" : "";

/** Absolute, because the pmtiles protocol needs a full URL, not a path. */
export function apiURL(path: string): string {
  return new URL(API + path, window.location.origin).toString();
}

// Start where the product started: the northern Lower Peninsula.
// The phone opens on the hunter's area at zoom 13.5. The desk has no "area" yet, so it opens on
// the last place you looked, or on Houghton Lake State Forest the first time.
const saved = (() => { try { return JSON.parse(localStorage.getItem("apex.view") ?? "null"); } catch { return null; } })();
export const START = {
  center: (saved?.center ?? [-84.62, 44.27]) as [number, number],
  zoom: (saved?.zoom ?? 12) as number,
};
export function rememberView(lng: number, lat: number, zoom: number): void {
  try { localStorage.setItem("apex.view", JSON.stringify({ center: [lng, lat], zoom })); } catch { /* private mode */ }
}
